var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 484.3 126.4",
    style: {
      enableBackground: "new 0 0 484.3 206.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#312B27;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M269.1,83.5l-13.9,14.9l-7-7.3h-40.8c-3.4-0.1-6-3-5.9-6.4c0.1-3.2,2.7-5.7,5.9-5.9c1.2,0.2,2.4,0.7,3.5,1.2 c1.1,0.5,2.4,0.4,3.4-0.4c1-0.8,1.5-2,1.3-3.2c-0.2-1-0.2-1.9-0.2-2.9c0-9.7,7.9-17.6,17.6-17.6c1.8,0,3.5,0.3,5.2,0.8l0.4,0.1 l5.6-4.9l-1.2-0.5c-3.2-1.4-6.6-2.1-10.1-2.1c-12.9,0-23.5,10.1-24.1,23c-0.5-0.1-0.9-0.1-1.4-0.1c-7-0.2-12.8,5.3-13,12.3 c-0.2,7,5.3,12.8,12.3,13c0.2,0,0.5,0,0.7,0h36.9l11,11.5l19.3-20.5L269.1,83.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 259.4,
    cy: 67.5,
    r: 5.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 259.4,
    cy: 53.4,
    r: 5.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 272.5,
    cy: 75.3,
    r: 5.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 259.4,
    cy: 81.6,
    r: 5.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 272.5,
    cy: 59.6,
    r: 5.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 246.2,
    cy: 75.3,
    r: 5.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 246.2,
    cy: 59.6,
    r: 5.6
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo_ICON.76d469685e1cc3cfeea612a13fb042f4.svg";
export { ForwardRef as ReactComponent };